import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'colorWithoutTitle'
})
export class ColorWithoutTitlePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    // color will be inside parentheses so we need the value in between the parentheses
    if (typeof value === 'string') {
      const colorIndex = value.indexOf('(');
      if (colorIndex > -1) {
        return value.slice(colorIndex + 1, value.length - 1);
      }
      return value;
    }
    return value;
  }

}
